import {
  LABEL_URL,
  FILE_URL,
  CONTACTS_URL
} from "../../../services/common-urls";
import { MHTTPCL, JSON_STRING } from "../../../services/http/http-client";

export const LabelsService = {
  getLabels: () =>
    MHTTPCL.get(LABEL_URL, {
      section: "labels",
      action: "",
      output: JSON_STRING
    }),
  addLabel: label_name =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "new_label",
      label_name
    }),
  fetchListLabel: (start,term, no_autofetch,royalty_status,type,label_status_ids) =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "search_labels",
      search:term,
      no_autofetch,
      type,
      royalty_status,
      label_status_ids,
      row_count:30,
      row_start:start,
      output: JSON_STRING
    }),
  removeLabel: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "remove_label",
      label_id
    }),
  fetchLabelDetails: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details",
      label_id,
      output: JSON_STRING
    }),
  fetchLabelDetailsTabOverview: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_overview",
      label_id,
      external_table: "label",
      output: JSON_STRING
    }),

  labelDetailsMetadata: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_metadata",
      label_id,
      output: JSON_STRING
    }),
  showMetadata: external_id =>
    MHTTPCL.post(LABEL_URL, {
      action: "show_metadata",
      external_table: "label",
      external_id,
      output: JSON_STRING
    }),
  fetchLabelDetailsTabInfo: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_info",
      label_id,
      output: JSON_STRING
    }).then(res => {
      return {
        ...res,
        data: {
          ...(res.data || {}),
          artwork1: `${MHTTPCL.getBaseUrl()}/files.pl?action=show_file&file_id=${
            res.data?.label?.artwork1
          }`,
          artwork2: `${MHTTPCL.getBaseUrl()}/files.pl?action=show_file&file_id=${
            res.data?.label?.artwork2
          }`
        }
      };
    }),

  fetchLabelReleasesProducts: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_search_releases_products",
      label_id,
      output: JSON_STRING
    }),

  labelDetailsTabSearchReleasesProducts: (label_id, search_term) =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_search_releases_products",
      label_id,
      search_term
    }),

  fetchLabelDetailsTabSetup: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_details_tab_setup",
      label_id,
      output: JSON_STRING
    }),

  deleteContactRelation: contact_relation_id =>
    MHTTPCL.post(CONTACTS_URL, {
      action: "delete_relation",
      contact_relation_id: contact_relation_id
    }),
  deleteLabelAccount: label_account_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "remove_label_account",
      label_account_id
    }),
  fetchLabelAccount: label_id =>
    MHTTPCL.get(LABEL_URL, {
      section: "labels",
      action: "label_add_account_form",
      label_id,
      output: JSON_STRING
    }),
  labelAddAccount: ({ account_ids, label_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "label_add_account",
      account_ids,
      label_id,
      output: JSON_STRING
    }),
  fetchLabelAccountTable: label_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "labels",
      action: "load_label_account_table",
      label_id,
      output: JSON_STRING
    })
};
